import React from "react";
import "react-app-polyfill/ie11";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import ChooseContact from "./components/ChooseContact";
import VerifyCode from "./components/VerifyCode";
import VerifySuccess from "./components/VerifySuccess";

export default class App extends React.Component {
	render() {
		return (
			<div className={"mp-two-factor-auth container"}>
				<Router>
					<Switch>
						<Route
							exact
							path="/"
							component={ChooseContact}
						/>
						<Route
							path="/verify-code"
							render={(props) => {
								return <VerifyCode {...props} />
							}}
						/>
						<Route
							path="/verified"
							render={(props) => {
								return <VerifySuccess {...props}/>
							}}
						/>
					</Switch>
				</Router>
			</div>
		);
	}
}